<!-- One box for every state, so switching between loading / error / content
     never resizes the pane around it. -->
<div class="h-full w-full overflow-hidden bg-ds-surface" data-testid="markdown-view">
  @if (loading()) {
    <!-- Skeleton lines rather than a spinner: they occupy the shape the prose
         will take, so the content does not jump in on arrival. -->
    <div class="h-full overflow-hidden p-6" aria-busy="true" aria-live="polite" data-testid="markdown-view-loading">
      <span class="sr-only">Loading markdown…</span>
      <div class="max-w-prose animate-pulse space-y-3">
        <div class="h-5 w-2/5 rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-3 w-full rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-3 w-11/12 rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-3 w-4/6 rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-24 w-full rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-3 w-10/12 rounded-ds-sm bg-ds-surface-muted"></div>
        <div class="h-3 w-3/6 rounded-ds-sm bg-ds-surface-muted"></div>
      </div>
    </div>
  } @else if (failure(); as failed) {
    <div
      class="flex h-full flex-col items-center justify-center gap-3 p-6 text-center"
      role="alert"
      data-testid="markdown-view-error">
      <mat-icon aria-hidden="true" class="text-ds-danger">error_outline</mat-icon>
      <p class="text-sm font-medium text-ds-text">{{ failed.title }}</p>
      <p class="max-w-sm text-xs leading-relaxed text-ds-text-muted">{{ failed.detail }}</p>
      <button
        type="button"
        (click)="retry()"
        data-testid="markdown-view-retry"
        class="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-ds-sm border border-ds-border bg-ds-surface px-3 text-xs font-medium text-ds-text transition-colors duration-150 hover:bg-ds-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary">
        <mat-icon aria-hidden="true" class="!h-4 !w-4 !text-[16px] !leading-4">refresh</mat-icon>
        Retry
      </button>
    </div>
  } @else if (content(); as html) {
    <div class="markdown-body thin-scroll h-full overflow-auto p-6" [innerHTML]="html"></div>
  } @else if (isEmpty()) {
    <div class="flex h-full items-center justify-center p-6 text-sm text-ds-text-muted" data-testid="markdown-view-empty">
      This document has no markdown content.
    </div>
  } @else {
    <div class="flex h-full items-center justify-center p-6 text-sm text-ds-text-muted" data-testid="markdown-view-idle">
      Markdown is not available for this document yet.
    </div>
  }
</div>
